import { toTitleCase } from '@libs/core';

import { getMappedBrandName } from './brandMapping';

export const denormalizeFilterName = (name: string) =>
    getMappedBrandName(toTitleCase(name.replaceAll('-', ' ').replaceAll(' and ', ' & ')));

export const normalizeFilterName = (name: string) =>
    name.trim().replace(/ /g, '-').replace(/&/g, 'and').replace(/'/g, '').toLowerCase();
